import { render, staticRenderFns } from "./SearchComboBox.vue?vue&type=template&id=540ed09b&scoped=true"
import script from "./SearchComboBox.vue?vue&type=script&lang=js"
export * from "./SearchComboBox.vue?vue&type=script&lang=js"
import style0 from "./SearchComboBox.vue?vue&type=style&index=0&id=540ed09b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ed09b",
  null
  
)

export default component.exports